
import {defineComponent} from 'vue';
// import Text from '@/components/Text/Text.vue';
import Text from '../Text/Text.vue';
// import Icon from '@/components/Icon/Icon.vue';
// import Icon from '../Icon/Icon.vue';

export default defineComponent({
  name: 'OxdMainMenuItem',

  components: {
    'oxd-text': Text,
    // 'oxd-icon': Icon,
  },

  props: {
    url: {
      type: String,
      required: false,
      default: '#',
    },
    active: {
      type: Boolean,
      required: false,
      default: false,
    },
    collapsed: {
      type: Boolean,
      required: false,
      default: false,
    },
    name: {
      type: String,
      required: false,
      default: '',
    },
    icon: {
      type: String,
      required: false,
      default: 'home',
    },
  },

  computed: {
    menuClasses(): object {
      return {
        'oxd-main-menu-item': true,
        active: this.active,
        toggle: this.collapsed,
      };
    },
  },
});
